import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import {
  ICON_CHEVRON_DIRECTION,
  ICON_HEIGHT_16,
  IconChevron,
} from '../../../Icon'
import { QA_NAME_DASHBOARD_BIRDVIEW_SHOW_ALL } from '../../DashboardBirdview.constants.qa'

function BirdviewCardShowAllButton({ onClick }) {
  const { t } = useTranslation()

  return (
    <Button.Text
      isInline
      afterIconProps={{
        Icon: IconChevron,
        height: ICON_HEIGHT_16,
        iconProps: { direction: ICON_CHEVRON_DIRECTION.RIGHT },
      }}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_SHOW_ALL}
      text={t('Common.ListShowAllBtnKey')}
      onClick={onClick}
    />
  )
}

export default BirdviewCardShowAllButton
